/**
 * The dot beside the team with the ball (ISSUE-1091). The same size as the
 * live badge's dot, in the ink color, never a team color, and never animated.
 * Decorative and never a tap target: the server's sentence names the team.
 */
import { cn } from "@sportsmet/ui";
import type { ReactNode } from "react";

export const PossessionDot = (props: { className?: string }): ReactNode => (
  <span
    aria-hidden="true"
    data-testid="possession-dot"
    className={cn(
      "pointer-events-none h-score-live-dot w-score-live-dot shrink-0 rounded-full bg-ink",
      props.className,
    )}
  />
);
